import { API_SOURCE } from "../../client/constants/app-constants";
import { STATE_CODES } from "../../client/constants/state-name-constants";
import { EXPERIMENT_NAME } from "../../client/utils/statsig-ab-utils/constant";

export const STATE_EXPERIMENT_MAP = {
    [STATE_CODES.VIC]: {
        [API_SOURCE.M_SITE]: EXPERIMENT_NAME.msite_sorting_victoria,
        [API_SOURCE.WEB_APP]: EXPERIMENT_NAME.desktop_sorting_victoria
    },
    [STATE_CODES.NSW]: {
        [API_SOURCE.M_SITE]: EXPERIMENT_NAME.msite_sorting_nsw,
        [API_SOURCE.WEB_APP]: EXPERIMENT_NAME.desktop_sorting_nsw
    },
    [STATE_CODES.QLD]: {
        [API_SOURCE.M_SITE]: EXPERIMENT_NAME.msite_sorting_queensland,
        [API_SOURCE.WEB_APP]: EXPERIMENT_NAME.desktop_sorting_queensland
    }
};
export const getListingExperimentKey = ({userGeoData, source}) => {

    const {state: {isoCode: customStateIsoCode = STATE_CODES.VIC} = {}} = userGeoData || {};
    if (!STATE_EXPERIMENT_MAP[customStateIsoCode]) {
        return STATE_EXPERIMENT_MAP[STATE_CODES.VIC][source];
    }
    return STATE_EXPERIMENT_MAP[customStateIsoCode][source];
};
